import { Stack } from '@mui/material';
import { type ReactNode } from 'react';

interface FilterBarProps {
  children: ReactNode;
}

export function FilterBar(props: FilterBarProps) {
  const { children } = props;
  return (
    <Stack direction="row" gap={1} flexWrap="wrap">
      {children}
    </Stack>
  );
}
